<template>
  <div class="blog-list-page">
    <div class="page-title">
      <div>新闻资讯列表</div>
      <div class="add" @click="$router.push({ name: 'NewBlog'})">+ 添加资讯</div>
    </div>
    <el-table :data="blogs" border stripe size="small">
      <el-table-column v-for="col in columns"
        :prop="col.prop"
        :key="col.id"
        :label="col.label"
        :width="col.width">
      </el-table-column>
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="deleteItem(scope.$index,scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="g-page-area">
      <el-pagination @current-change="currentPageChange" :current-page.sync="page" :page-size="15" layout="total, prev, pager, next" :total="total" background></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      blogs: [{}],
      total: 0,
      page: 1,
      columns: [
        { id: 1, prop: 'id', label: '编号', width: '100px' },
        { id: 2, prop: 'title', label: '标题', width: '' },
        { id: 3, prop: 'create_time', label: '创建时间', width: '150px' }
      ]
    }
  },
  methods: {
    currentPageChange (page) {
      this.getBlogs(page)
    },
    deleteItem (index, id) {
      this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(index, id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleDelete (index, id) {
      const that = this
      that.axios.delete('admin/blog/' + id).then(function (resp) {
        if (resp.data.code === 0) {
          that.$message.success('删除成功')
          that.blogs.splice(index, 1)
          that.total = that.total - 1
        }
        if (resp.data.code === 1) {
          that.$message.error(resp.data.msg)
        }
      })
    },
    getBlogs (page) {
      const that = this
      that.axios.get('admin/blog', { params: { page } }).then(function (resp) {
        if (resp.data.code === 0) {
          that.total = resp.data.total
          that.blogs = resp.data.blogs
        }
      })
    }
  },
  mounted () {
    this.getBlogs(1)
  }
}
</script>

<style scoped>
.blog-list-page{
  max-width: 1200px;
  margin: auto;
  box-sizing: border-box;
  padding: 50px 20px;
}
.page-title{
  max-width: 1200px;
  margin: 10px auto 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid #DCDFE6;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.add{
  font-size: 14px;
  cursor: pointer;
  color: #409EFF;
}
</style>
